import React from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "../Icon.png";
// import "../OMS order list.css";
import NavBar from "../NavBar";
export default function WarehouseProducts(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.qty.toString() === e.target.value));
  };
  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.value < 10000
      } 
      else if (e.target.value === '2') {
        return x.value > 5000
      }
      else if (e.target.value === '3') {
        return x.value > 10000
      }
    }));
  };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Warehouse Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Products</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Products</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p>All Products</p>
            <p>Recently Added</p>
            <p>Recently Removed</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by product ID, SKU..."
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.productId.match(val.target.value) || x.sku.match(val.target.value)
                  )
                );
                setFiltr1('')
                setFiltr2('')
              }}
            />
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
              value={filtr1}
              onChange={handleFilter1}
              >
                <option value="" selected>
                  Quantity
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr2}
              onChange={handleFilter2}
              >
                <option selected>Value</option>
                <option value="1">&lt;10000</option>
                <option value="2">&gt;5000</option>
                <option value="3">&gt;10000</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Product ID</th>
              <th>SKU</th>
              <th>Supplier</th>
              <th>Item Name</th>
              <th>Qty</th>
              <th>Value</th>
              <th>Location</th>
              <th>Reorder Level</th>
              <th>Reorder Days</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.productId}</td>
                  <td>{val.sku}</td>
                  <td>{val.supplier}</td>
                  <td>{val.item}</td>
                  <td>{val.qty}</td>
                  <td>{val.value}</td>
                  <td>{val.location}</td>
                  <td>{val.reorderLevel}</td>
                  <td>{val.reorderDays}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.productId}</td>
                  <td>{val.sku}</td>
                  <td>{val.supplier}</td>
                  <td>{val.item}</td>
                  <td>{val.qty}</td>
                  <td>{val.value}</td>
                  <td>{val.location}</td>
                  <td>{val.reorderLevel}</td>
                  <td>{val.reorderDays}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export const IncomingData = [
  {
    "productId": "KCVF112L",
    "sku": "KCVF17777",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 4,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF1222",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 3,
    'value': 99999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF18888",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 1,
    'value': 99777,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF11111",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 3598,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF11111",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 2821,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF11111",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 5960,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF11111",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 7521,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF11111",
    "sku": "KCVF11111",
    'supplier':'Dora',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 56952,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'michti',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 1,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 3,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 4,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 1,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 4,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 4,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 3,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 2,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
  {
    "productId": "KCVF112L",
    "sku": "KCVF112L",
    'supplier':'John Doe',
    'item': `Nike men's air zoom shoe`,
    'qty': 1,
    'value': 9999,
    'location': 'Warehouse Name',
    'reorderLevel': 14,
    'reorderDays': 14
  },
];
